import './index.css'
import ReactSwitch from "react-switch";
import {Controller, useFieldArray, useFormContext} from "react-hook-form";
import Button from "@/components/common/Button";
import { ReactComponent as RiAddLine } from "@/assets/icons/ri-add-line.svg";
import { ReactComponent as RiTimerLine } from "@/assets/icons/ri-timer-line.svg";
import { ReactComponent as RiTimeLine } from "@/assets/icons/ri-time-line.svg";
import { ReactComponent as RiDeleteBinLine } from '@/assets/icons/ri-delete-bin-line.svg'
import TimeInput from "@/components/common/TimeInput";
import {hourFormat} from "@/utils";

const onChangeTimeInput = (onChange: Function, e: Event) => {
  const target = e.target as HTMLInputElement
  onChange(target.value.split(':')[0])
}

const renderHourRuleRows = (hourRules: HourRuleVO[], remove: Function, control) => (
  hourRules.map((h,index) => (
    <div key={h.generatedId} className="flex gap-3 items-center">
      <div className="p-2 bg-blue-light rounded text-white">
        <RiTimerLine/>
      </div>
      <div className="flex-grow text-jbase font-bold text-blue-light">
        Periode {index + 1}
      </div>
      <div className="flex flex-grow flex-nowrap flex-row justify-between items-center py-2 px-4 bg-white-subtle border border-grey-line-subtle rounded">
        <div className="flex gap-4 justify-start items-center">
          <Controller
            control={control}
            render={({field}) =>
              <TimeInput
                onChange={(e) => { onChangeTimeInput(field.onChange, e) }}
                value={hourFormat(field.value)}/>}
            name={`hour_rule_setting_details.${index}.start_time`}/>
          <div> - </div>
          <Controller
            control={control}
            render={({field}) =>
              <TimeInput
                onChange={(e) => { onChangeTimeInput(field.onChange, e)}}
                value={hourFormat(field.value)}/>}
            name={`hour_rule_setting_details.${index}.end_time`}/>
        </div>
        <div className="flex justify-center items-center text-grey-dark h-4 w-4">
          <RiTimeLine className="h-4 w-4"/>
        </div>
      </div>
      <button
        onClick={() => {
          remove(index)
        }}
        type="button"
        className="text-red-primary">
        <RiDeleteBinLine/>
      </button>
    </div>
  ))
)

const Setting = () => {
  const { control } = useFormContext()
  const hourRulesField = useFieldArray({
    name: 'hour_rule_setting_details',
    keyName: 'generatedId'
  })
  const handleClickAddCourt = () => {
    const newHourRule: HourRule = {
      start_time: 0,
      end_time: 0
    }
    hourRulesField.append(newHourRule)
  }

  return <div className="card-base flex w-full flex-col">
    <div className="text-jlg mb-7">Setting</div>
    <div className="flex w-full justify-between items-center pb-6 mb-6 border-b border-b-grey-line-subtle">
      <div className="flex flex-col flex-grow">
        <div className="text-jbase font-bold">1 Hour Rule</div>
        <div className="text-jsm text-grey-dark font-normal">Forbidden to leave 1 hour between 2 active hours</div>
      </div>
      <Controller
        render={({field}) =>
          <ReactSwitch
            checked={field.value}
            uncheckedIcon={null}
            checkedIcon={null}
            offColor="#D0D2D8"
            onColor="#EE1D23"
            {...field} />}
        name="hour_rule_setting"
      />
    </div>
    <div className="text-jbase font-bold mb-4">
      Setting Periode
    </div>
    <div className="flex flex-col gap-5 w-full">
      {renderHourRuleRows(
        hourRulesField.fields as HourRuleVO[],
        hourRulesField.remove,
        control
      )}
    </div>
    <div>
      <Button
        onClick={handleClickAddCourt}
        type="button"
        variant="tertierry"
        className="whitespace-nowrap flex gap-2 pl-4 py-2 justify-center items-center mt-5 p-0 pl-0 py-0">
        <div className="w-[18px] text-red-primary">
          <RiAddLine/>
        </div>
        <span className="text-jsm">Add Periode</span>
      </Button>
    </div>
  </div>
}

export default Setting;